import React, {PropsWithChildren} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {BackButtonComponent} from "../../basic-componentes/back-button.component";
import {VERTICAL_SPACING_PX} from "../../css-global-constants";

const MobileHeaderBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    background-color: ${props => props.theme.colors.lightShade};
    font-size: ${props => props.theme.fontSize.medium};
    margin-bottom: ${VERTICAL_SPACING_PX};
    padding: 8px;
`

const MobileHeaderContentBox = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
   
`

interface MobileDropDownListHeaderComponentProps extends PropsWithChildren {
    onBackClick: () => void;
}
export const MobileDropDownListHeaderComponent: React.FC<MobileDropDownListHeaderComponentProps> = observer((props) => {
    return (
        <MobileHeaderBox>
            <BackButtonComponent onClick={props.onBackClick}/>
            <MobileHeaderContentBox>
                {props.children}
            </MobileHeaderContentBox>

        </MobileHeaderBox>
    )
});
